import { Auth0Provider, AppState } from '@auth0/auth0-react';
import React, { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { safeReturnTo } from './components/Auth0/returnTo';

interface Props {
  children: React.ReactNode;
}

export const Auth0ProviderWithNavigate = ({
  children,
}: PropsWithChildren<Props>): React.JSX.Element | null => {
  const navigate = useNavigate();

  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri =
    process.env.REACT_APP_AUTH0_CALLBACK_URL || `${window.location.origin}/callback`;
  const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

  // Back from Auth0 the callback page always runs first (it sets up the user, organisation and legal
  // gate); it is handed the page the person was going to, if any, and goes there afterwards.
  const onRedirectCallback = (appState?: AppState) => {
    const returnTo = safeReturnTo(appState?.returnTo);
    navigate(window.location.pathname, returnTo ? { state: { returnTo } } : undefined);
  };

  if (!(domain && clientId && redirectUri && audience)) {
    return (
      <div style={{ padding: '20px', background: 'red', color: 'white' }}>
        <h2>Auth0 Configuration Error</h2>
        <p>Missing one or more required environment variables.</p>
      </div>
    );
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: redirectUri,
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useCookiesForTransactions={true}
    >
      {children}
    </Auth0Provider>
  );
};
